import { Plus } from "lucide-react"

export default function AdminHeader({ 
  title, 
  subtitle, 
  showCreateButton = false, 
  createButtonText = "Créer",
  onCreateClick 
}) {
  return (
    <header className="flex items-center justify-between mb-8">
      <div>
        <h1 className="text-3xl font-bold text-gray-900">{title}</h1>
        {subtitle && <p className="text-gray-600">{subtitle}</p>}
      </div>
      {showCreateButton && (
        <button
          onClick={onCreateClick}
          className="flex items-center space-x-2 px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-hover transition-colors font-display"
        >
          <Plus size={20} />
          <span>{createButtonText}</span>
        </button>
      )}
    </header>
  )
}
